export const DIGITAL_WALLET_NAMES: Record<string, string> = {
  google_pay: 'Google Pay',
  apple_pay: 'Apple Pay',
  click_to_pay: 'Click to Pay',
};

export const CARD_BRAND_NAMES: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  elo: 'Elo',
  amex: 'American Express',
  dinersclub: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
};

export const PAYMENT_METHODS_WITH_INSTALLMENTS = [
  'credit_card',
  'digital_wallet',
  'delivery_link',
  'unique_link',
  'catalog',
];

export const PAYMENT_METHODS_WITHOUT_INSTALLMENTS = [
  'pix',
  'boleto',
  'subscription',
];
